<template>
  <el-card style="height: 740px; overflow-y: scroll">
    <div class="region">
      <p>OCR使用模型管理</p>
      <el-select v-model="ocr_model" @change="change_ocr_model">
        <el-option :value="0" label="gpt-4o"></el-option>
        <el-option :value="1" label="moonshot-v1-auto"></el-option>
        <el-option :value="2" label="ep-20241219161215-p2qsp"></el-option>
        <el-option :value="3" label="deepseek-chat"></el-option>
        <el-option :value="4" label="qwen-max"></el-option>
      </el-select>
    </div>
    <div class="region">
      <p>模型管理</p>
      <el-table
        border
        :data="tableData"
        :header-cell-style="{ 'background-color': '#f6f6f6' }"
        style="width: 100%; margin-top: 20px"
      >
        <el-table-column
          align="center"
          prop="model"
          label="使用模型"
        ></el-table-column>
        <el-table-column align="center" prop="is_activation" label="是否激活">
          <template slot-scope="scope">
            <el-switch
              @change="change_switch(scope.row)"
              v-model="scope.row.is_activation"
              active-color="#13ce66"
              inactive-color="#ff4949"
            ></el-switch>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-card>
</template>

<script>
import { get_model, edit_model } from "@/api/model";
import { get_ocr_model, edit_ocr_model } from "@/api/ocr_model";

export default {
  name: "RegionView",
  data: function () {
    return {
      tableData: [],
      form: {
        is_activation: false,
      },
      ocr_model: 2,
    };
  },
  methods: {
    get_model_data() {
      get_model().then((res) => {
        const { data } = res;
        if (data["code"] === 200) {
          this.tableData = data["data"];
        }
      });
    },
    change_switch(row) {
      this.form = row;
      this.submit();
    },
    dialog_close() {
      this.form = {
        is_activation: false,
      };
    },
    submit() {
      edit_model(this.form.is_activation, this.form.id).then((res) => {
        const { data } = res;
        if (data["code"] === 200) {
          this.$message.success("编辑成功！");
          this.get_model_data();
        } else {
          this.$message.error(data["error"]);
        }
      });
    },
    get_ocr_model() {
      get_ocr_model().then((res) => {
        const { data } = res;
        if (data["code"] === 200) {
          this.ocr_model = data["model"];
        }
      });
    },
    change_ocr_model(model) {
      edit_ocr_model(model).then((res) => {
        const { data } = res;
        if (data["code"] === 200) {
          this.$message.success("修改成功！");
        } else {
          this.$message.error(data["error"]);
        }
      });
    },
  },
  created() {
    this.get_ocr_model();
    this.get_model_data();
  },
  computed: {},
  watch: {},
};
</script>

<style lang="scss" scoped>
.el-card {
  width: 99%;
}
</style>
